import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';
import { User } from '../../types/schema';

interface DeleteUserModalProps {
    user: User | null;
    isDeleting: boolean;
    isListedCompanyOwner: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteUserModal = ({
    user,
    isDeleting,
    isListedCompanyOwner,
    onDismiss,
    onConfirmDelete,
}: DeleteUserModalProps) => {
    const visible = Boolean(user?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, user?.id]);

    const userName = user?.name?.trim() || 'this user';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete user?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to permanently delete <strong>“{userName}”</strong>. This cannot be undone.
            </p>
            {isListedCompanyOwner && (
                <p>
                    This person is still listed as the company owner from the seeded/copied company.
                    Deleting them also removes the owner record and reassigns ownership to your signed-in
                    account so they do not come back on refresh.
                </p>
            )}
        </CustomModal>
    );
};
